module.exports = __webpack_public_path__ + "static/media/mc.18625911.jpg";